import React from 'react';
import { ColorVariantsDesktopVersion } from './color-variants-desktop-version';
import { ColorVariantsMobileVersion } from './color-variants-mobile-version';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import { createNewSelection } from '../utils/selections';
import type { IVariants } from '../types';

const FILTER_TYPE = FilterType.VARIANT_COLOR;

export const ColorVariants: React.FC<IVariants> = props => {
  const { distinctValues, isMobile } = props;
  const { getFilter, setFilterSelection, toggleFilter } =
    useOfferListFilterContext();
  const filter = getFilter(FILTER_TYPE);
  const selection =
    filter?.active && filter?.selection ? filter?.selection : [];

  const handleSelection = (variant: string | null) => {
    const newSelection = createNewSelection(
      variant,
      selection?.length ? selection : []
    );
    if (filter?.active && newSelection.length === 0) {
      toggleFilter(FILTER_TYPE);
    } else {
      setFilterSelection(FILTER_TYPE, newSelection);
    }
  };

  if (distinctValues.length <= 1) {
    return null;
  }

  return isMobile ? (
    <ColorVariantsMobileVersion
      handleSelection={handleSelection}
      variants={distinctValues}
      isMobile={isMobile}
    />
  ) : (
    <ColorVariantsDesktopVersion
      handleSelection={handleSelection}
      variants={distinctValues}
      isMobile={isMobile}
    />
  );
};
